import { render, staticRenderFns } from "./BroadOpenAnswer.vue?vue&type=template&id=5eda0459&scoped=true&"
import script from "./BroadOpenAnswer.vue?vue&type=script&lang=ts&"
export * from "./BroadOpenAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./BroadOpenAnswer.vue?vue&type=style&index=0&id=5eda0459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda0459",
  null
  
)

export default component.exports